import { SheetsSettings } from 'records/SheetsSettings';
import Immutable from 'immutable';

export interface RawProjectSettings {
  sheets: SheetsSettings;
}

export interface ProjectSettingsData {
  sheets: SheetsSettings;
}

const defaultValues: ProjectSettingsData = {
  sheets: new SheetsSettings(),
};

export const ProjectSettingsFactory = Immutable.Record(
  defaultValues,
  'ProjectSettings'
);

export class ProjectSettings extends ProjectSettingsFactory {
  static deserialize(projectSettings: RawProjectSettings): ProjectSettings {
    return new ProjectSettings({
      ...projectSettings,
      sheets: projectSettings.sheets,
    });
  }

  serialize(): RawProjectSettings {
    return this.toJS();
  }
}
